/**
 * Aitopia — multi-model AI chat / agents
 *
 * Declares one web-accessible-resource entry matched to every origin, exposing broad
 * globs (*.png, *.svg, *.js, *.css, *.html and the whole assets/ tree) with no
 * `use_dynamic_url`. So its vendor-named files are all fetchable from any page at a
 * fixed URL. The `aitopia.png` icon at the package root is the cleanest signal — a
 * vendor-named image that loads through `probeImage` with no CORS grant.
 *
 * Manifest verified against version 6.9.0.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'becfinhbfclcgokjlobojlnldbfillpf';

export const aitopia: ExtensionDefinition = {
  id: ID,
  name: 'Chat with all AI models (Gemini, Claude, DeepSeek…) & AI Agents | AITOPIA',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 900_000,
  notes:
    'Broad static WAR globs on every origin with no dynamic URL. The vendor-named ' +
    'aitopia.png loads without a CORS grant and is conclusive.',
  signals: [
    {
      id: 'war-aitopia-png',
      kind: 'web-accessible-resource',
      description:
        'Load aitopia.png via <img> — the vendor-named brand icon at the package root, ' +
        'exposed to every origin and readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'aitopia.png'),
    },
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load assets/images/icon128.png via <img> — a second image path corroborating ' +
        'the identification.',
      weight: 0.5,
      run: () => probeImage(ID, 'assets/images/icon128.png'),
    },
    {
      id: 'war-marketplace-router-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch marketplace_router.js — a vendor-named script at the root, independent ' +
        'of the image paths.',
      weight: 0.5,
      run: () => probeFetch(ID, 'marketplace_router.js'),
    },
  ],
};
